<template>
   <div class="preview-mask">
      <component 
         class="preview-content"
         v-bind:is="templateComponent"
         :inCanvas="false"
         :json="json"
      ></component>

      <div class="close-btn" @click="$emit('close')">
         X
      </div>
   </div>
</template>

<script>
import MediaCardPreview from "./templates/62/MediaCardPreview"
import ScoreboardPreview from './templates/67/ScoreboardPreview'

import SoccerScoreboardPreview from './templates/73/SoccerScoreboardPreview'
import SoccerScoreboardNoVideoPreview from './templates/74/SoccerScoreboardNoVideoPreview'

import FootballScoreboardPreview from './templates/75/FootballScoreboardPreview'
import FootballScoreboardNoFeedPreview from './templates/82/FootballScoreboardNoFeedPreview'

import LacrosseScoreboardPreview from './templates/76/LacrosseScoreboardPreview'
import LacrosseScoreboardNoVideoPreview from './templates/77/LacrosseScoreboardNoVideoPreview'

import BasketballScoreboardPreview from './templates/87/BasketballScoreboardPreview'
import VolleyballScoreboardPreview from './templates/90/VolleyballScoreboardPreview'

import PlayerProfilePreview from './templates/66/PlayerProfilePreview' 
import PlayerProfileSolonPreview from './templates/66/PlayerProfileSolonPreview'
import VideoSlideshowPreview from './templates/68/VideoSlideshowPreview'
import VideoPlayerPreview from './templates/72/VideoPlayerPreview'


export default {
   props: {
      json: {},
      templateRecid: ''
   },

   created() {
      this.$parent.$emit('previewCreated');
   },

   components: {
      MediaCardPreview,
      ScoreboardPreview,
      PlayerProfilePreview,
      PlayerProfileSolonPreview,
      VideoPlayerPreview,
      VideoSlideshowPreview,
      SoccerScoreboardPreview,
      SoccerScoreboardNoVideoPreview,
      FootballScoreboardPreview,
      FootballScoreboardNoFeedPreview,
      LacrosseScoreboardPreview,
      LacrosseScoreboardNoVideoPreview,
      BasketballScoreboardPreview,
      VolleyballScoreboardPreview
   },

   computed: {
      templateComponent() {
         if (this.templateRecid == 67) {
            return 'scoreboard-preview';
         } else if (this.templateRecid == 66) {
            // return 'player-profile-preview';
            return 'player-profile-solon-preview';
         } else if (this.templateRecid == 62) {
            return 'media-card-preview';
         } else if (this.templateRecid == 68) {
            return 'video-slideshow-preview';
         } else if (this.templateRecid == 72) {
            return 'video-player-preview';
         } else if (this.templateRecid == 73) {
            return 'soccer-scoreboard-preview';
         } else if (this.templateRecid == 74) {
            return 'soccer-scoreboard-no-video-preview';
         } else if (this.templateRecid == 75) {
            return 'football-scoreboard-preview';
         } else if (this.templateRecid == 76) {
            return 'lacrosse-scoreboard-preview';
         } else if (this.templateRecid == 77) {
            return 'lacrosse-scoreboard-no-video-preview';
         } else if (this.templateRecid == 82) {
            return 'football-scoreboard-no-feed-preview';
         } else if (this.templateRecid == 87) {
            return 'basketball-scoreboard-preview';
         } else if (this.templateRecid == 89) {
            return 'basketball-scoreboard-preview';
         } else if (this.templateRecid == 90) {
            return 'volleyball-scoreboard-preview';
         }
      }
   }
}
</script>

<style lang="scss" scoped>
.preview-mask {
   position: fixed;
   z-index: 9998;
   top: 0;
   left: 0;
   width: 100%;
   // max-width: 1920px;
   height: 100%;
   background-color: rgba(0, 0, 0, .9);
   display: table;
   transition: opacity .3s ease;

   display: flex;
   align-items: center;
}

.preview-content {
   margin: 0 auto;
}

.close-btn {
   position: absolute;
   top: 34px;
   right: 75px;
   background: $error-red;
   border-radius: 30px;
   padding: 1px 6px;
   font-size: 12px;
   color: white;
   z-index: 100;

   &:hover {
      cursor: pointer;
   }
}

</style>
